export interface MaintenanceConfigResponse {
  [key: string]: boolean;
}

export enum MaintenanceConfigFeature {
  ONE_UPGRADE = 'disableOneUpgrade',
}
